import { render, staticRenderFns } from "./ResourceListPage.vue?vue&type=template&id=2e9d147b&scoped=true&"
import script from "./ResourceListPage.vue?vue&type=script&lang=js&"
export * from "./ResourceListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9d147b",
  null
  
)

export default component.exports